import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import Card from 'components/common/cards/Card'
import Icon from 'components/common/Icon'
import Title from 'components/common/Title'
import { Container, Row, Col } from 'react-bootstrap'
import useOnClickOutside from 'hooks/useOnClickOutside'

const PopupContainer = styled.div`
	position: fixed;
	z-index: 999;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.5);
	overflow: auto;
`

const PopupTitle = styled(Title)`
	font-size: 30px;
	margin-right: 50px;
`

const PopupCloseIcon = styled(Icon)`
	position: absolute;
	top: 10px;
	right: 10px;
	:hover {
		cursor: pointer;
	}
	/* @media (max-width: 768px) {
    top: 5px;
    right: 5px;
  } */
`

const Popup = ({
	title = '',
	initialOpen,
	open,
	onClose = () => console.log('Popup Close Clicked'),
	children,
}) => {
	const ref = useRef()
	const [_isOpen, setIsOpen] = useState(initialOpen)
	useOnClickOutside(ref, () => setIsOpen(false))
	let isOpen = _isOpen || open ? true : false

	if (!isOpen) return null

	return (
		<PopupContainer
			onClick={(e) => {
				e.stopPropagation()
				setIsOpen(false)
				onClose()
			}}
		>
			<Container>
				<Row>
					<Col xs='12' lg={{ offset: 2, span: 8 }}>
						<Card
							style={{ marginTop: 50, marginBottom: 50, position: 'relative' }}
							ref={ref}
							onClick={(e) => e.stopPropagation()}
						>
							{title && <PopupTitle>{title}</PopupTitle>}
							<PopupCloseIcon
								icon={'times-circle'}
								style={{
									height: 'auto',
								}}
								onClick={() => {
									setIsOpen(false)
									onClose()
								}}
								size={30}
							/>
							{children}
						</Card>
					</Col>
				</Row>
			</Container>
		</PopupContainer>
	)
}

export default Popup
